export const getNewsletterUser = /* GraphQL */ `
  query GetNewsletterUser(
    $emailAddress: ID!
  ) {
    getNewsletterUser(id: $emailAddress) {
      confirmationDate
      emailAddress
      id
      owner
      username
      registrationDate
    }
  }
`

export const createNewsletterUser = /* GraphQL */ `
  mutation CreateNewsletterUser(
    $input: CreateNewsletterUserInput!
  ) {
    createNewsletterUser(input: $input) {
      confirmationDate
      emailAddress
      id
      owner
      username
      registrationDate
    }
  }
}
`

export const deleteNewsletterUser = /* GraphQL */ `
  mutation DeleteNewsletterUser(
    $input: DeleteNewsletterUserInput!
  ) {
    deleteNewsletterUser(input: $input) {
      id
    }
  }
`

export const createGdprReport = /* GraphQL */ `
  mutation CreateGdprReport(
    $userId: ID!,
    $identityId: String
  ) {
    createUserDataReport(userId: $userId, identityId: $identityId)
  }
`

export const listPriceModels = /* GraphQL */ `
  query ListPriceModels {
    listPriceModels {
      items {
        id
        order
        price
        priceId
        price1Y
        price1YId
        name
        highlightColor
        displayFeaturesDescription
        permissions {
          enabled
          featureId
          limited
        }
      }
    }
  }
`

// listPriceModelsGuests is called when a user is not logged in and is looking at the prices on the price page in Webflow (or on the url /abonnements).
export const listPriceModelsGuests = /* GraphQL */ `
  query ListPriceModels {
    listPriceModels {
      items {
        id
        order
        price
        price1Y
        name
        highlightColor
        displayFeaturesDescription
      }
    }
  }
`

export const listUserPortfolios = /* GraphQL */ `
  query ListPortfoliosByOwner(
    $ownerID: String!
  ) {
    listPortfoliosByOwner(owner: $ownerID, inclInactive: true, sortDirection: DESC) {
      items {
        id
        inactive
        name
      }
    }
  }
`

export const listUserWatchlists = /* GraphQL */ `
  query ListOwnerWatchlist(
    $ownerID: String!
  ) {
    listOwnerWatchlist(owner: $ownerID, inclInactive: true, sortDirection: DESC) {
      items {
        id
        inactive
        name
      }
    }
  }
`
